// extracted by mini-css-extract-plugin
export default {"container":"DetailsBox_container__UP15t"};